export enum SupplementaryParcelPurchaseControlName {
  LawPerson = 'lawPerson',
  Place = 'place',
  Street = 'street',
  DecisionForm = 'decisionForm',
  ShippingForm = 'shippingForm',
  Comments = 'comments'
}
